import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal modal-daily-record" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-header-title" }
const _hoisted_5 = { class: "modal-tab" }
const _hoisted_6 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_7 = { class: "modal-info" }
const _hoisted_8 = { class: "daily-record-contents" }
const _hoisted_9 = { class: "daily-record-contents-item-title" }
const _hoisted_10 = { class: "daily-record-category radio" }
const _hoisted_11 = ["id", "value", "onUpdate:modelValue"]
const _hoisted_12 = ["for"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "daily-record-add-container" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_18 = { class: "modal-info" }
const _hoisted_19 = { class: "daily-record-feelings" }
const _hoisted_20 = ["id", "value"]
const _hoisted_21 = ["for"]
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { class: "daily-record-feelings-item-name" }
const _hoisted_24 = { class: "modal-footer" }
const _hoisted_25 = { class: "modal-footer-buttons" }
const _hoisted_26 = {
  key: 2,
  id: "generalpurpose02-00-b04"
}
const _hoisted_27 = { class: "modal home-popup" }
const _hoisted_28 = { class: "modal-header" }
const _hoisted_29 = { class: "modal-body" }
const _hoisted_30 = { class: "popup-contents" }
const _hoisted_31 = ["alt"]
const _hoisted_32 = { class: "popup-contents-title" }
const _hoisted_33 = { class: "popup-contents-text" }
const _hoisted_34 = { class: "modal-footer" }
const _hoisted_35 = { class: "modal-footer-buttons" }

import {
  reactive,
  ref,
  watch,
  type PropType,
  getCurrentInstance,
  computed,
} from "vue";
import { Home } from "@/models/home";
import { _$t } from "@/utils/i18n";
import { processing, processend } from "@/utils/view";
import ErrorDialog from "@/views/base/CommonMessage.vue";
import CharCounterTextArea from "@/views/base/CharCounterTextArea.vue";

interface DailyNote {
  category: string;
  content: string;
  sub_number?: number;
}

interface DailyFeeling {
  feeling_option_id: number;
}

interface NoteCategoryOption {
  option_id: number;
  value?: number | string;
  display_name: string;
}

interface FeelingOption {
  option_id: number;
  value?: number | string;
  display_name: string;
}

type Tab = "symptom" | "feeling";

// ▼ トースト表示用

export default /*@__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
  isOpen: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "Modal Title",
  },
  selectedDate: {
    type: String,
    default: "",
  },
  dailyFeelings: {
    type: Array as PropType<DailyFeeling[]>,
  },
  dailyNotes: {
    type: Array as PropType<DailyNote[]>,
    default: () => [
      {
        category: "6",
        note: "",
      },
    ],
  },
  noteCategoryOptions: {
    type: Array as PropType<NoteCategoryOption[]>,
    default: () => [],
  },
  feelingOptions: {
    type: Array as PropType<FeelingOption[]>,
    default: () => [],
  },
  selectedTab: {
    type: String,
    default: "symptom",
  },
},
  emits: ["close-modal", "get-home-data"],
  setup(__props, { emit: __emit }) {

const { appContext } = getCurrentInstance()!;
const $toast = appContext.config.globalProperties.$toast;

const props = __props;

let errorDialog = reactive({
  show: false,
  okName: _$t("home_ok_btn"),
  okButtonHide: true,
  safe: true,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
  ok: (): void => {
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
    errorDialog.close();
  },
});

const infoModal = reactive({
  show: false,
  open: (): void => {
    infoModal.show = true;
  },
  close: (): void => {
    infoModal.show = false;
  },
});

const emit = __emit;

const isSelected = ref<Tab>(props.selectedTab as Tab);

const select = (str: Tab) => {
  isSelected.value = str;
};

const recordList = ref<Array<any>>([]);
const feelings = ref<Array<string>>([]);
let sessionErr = ref(false);

// デフォルトのカテゴリー（症状）のIDを取得
const defaultCategoryId = () => {
  const symptomCategory = props.noteCategoryOptions?.find(
    (option) => String(option.value) === "1"
  );
  return String(
    symptomCategory?.option_id ??
      props.noteCategoryOptions?.[0]?.option_id ??
      ""
  );
};

// カテゴリーフィルター
// 「薬の影響」を見た目上非表示
const filteredNoteCategoryOptions = computed(() => {
  return props.noteCategoryOptions.filter(
    (option) => String(option.value) !== "2"
  );
});

const syncDailyNotesValues = () => {
  recordList.value = props.dailyNotes?.length
    ? props.dailyNotes.map((item: any) => ({
      content: item.content,
      category: String(item.note_category_option_id),
      sub_number: item.sub_number,
    }))
    : [{ category: defaultCategoryId(), content: "" }];
};

const syncDailyFeelingsValues = () => {
  feelings.value = props.dailyFeelings?.length
    ? [
      ...new Set(
        props.dailyFeelings.map((item: any) => String(item.feeling_option_id))
      ),
    ]
    : [];
};

watch(
  () => props.dailyNotes,
  () => syncDailyNotesValues()
);

watch(
  () => props.dailyFeelings,
  () => syncDailyFeelingsValues()
);

const handleAddNote = () => {
  if (isNoteLimitReached()) return;
  recordList.value.push({ category: defaultCategoryId(), content: "" });
};

const isNoteLimitReached = (): boolean => {
  return recordList.value.length >= 10;
};

const getCategoryClass = (optionValue?: number | string): string => {
  const classMap: Record<number, string> = {
    1: "symptom",
    2: "treatment-effect",
    3: "worry",
    4: "other",
  };
  return classMap[Number(optionValue)] ?? "";
};

const getFeelingIcon = (optionValue?: number | string): string => {
  return `/server/necs/images/icon_feeling_${Number(optionValue)}.png`;
};

const handleDeleteNoteBtnClick = (_item: DailyNote, index: number) => {
  // 既存/新規とも、削除ボタン押下時点では画面上だけ削除する
  recordList.value.splice(index, 1);
};

const close = () => {
  isSelected.value = "symptom";
  syncDailyFeelingsValues();
  syncDailyNotesValues();
  emit("close-modal");
};

const handleSaveButtonClick = async () => {
  await handleSaveAll();
};

const handleSaveAll = async () => {
  // 未入力ノートは保存対象から除外する
  const notesToSave = recordList.value.filter(
    (item: DailyNote) => item.content?.trim() && item.category
  );
  const notesModel = new Home();

  if (notesToSave.length > 0) {
    // 記録がある場合、ポップアップメッセージ非表示フラグを更新する
    await notesModel.setSymptomHiddenFlag();
  }

  await notesModel
    .recordDailyNotes({
      answeredDate: props.selectedDate,
      dailyNotes: notesToSave,
    })
    .then(([model, _response, err]) => {
      if (err) {
        const status = err.error?.response?.status;
        const decodedMessage = decodeURIComponent(
          err.error?.response?.data?.message
        );
        if (status === 408) sessionErr.value = true;
        errorDialog.open(decodedMessage);
        return;
      }
    });
  if (errorDialog.show) return;

  const feelingsModel = new Home();
  await feelingsModel
    .recordDailyFeeling({
      answeredDate: props.selectedDate,
      optionsId: [...feelings.value],
    })
    .then(([model, _response, err]) => {
      if (err) {
        const status = err.error?.response?.status;
        const decodedMessage = decodeURIComponent(
          err.error?.response?.data?.message
        );
        if (status === 408) sessionErr.value = true;
        console.error(status, decodedMessage);
        errorDialog.open(decodedMessage);
        return;
      }
      $toast({
        message: `${_$t("home_modal_title_today_detail_record")}${_$t(
          "common_message_saved"
        )}`,
        icon: "success",
      });
      emit("get-home-data");
      close();
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: 
      isSelected.value === 'symptom'
        ? 'generalpurpose02-00-a01'
        : 'generalpurpose02-00-a02'
    
        }, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1),
              _createElementVNode("button", {
                type: "button",
                class: "modal-close",
                onClick: close
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("img", { src: "/server/necs/images/close-btn.png" }, null, -1)
              ]))
            ]),
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", {
                class: _normalizeClass(["modal-tab-item", isSelected.value === 'symptom' ? 'active' : '']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (select('symptom')))
              }, _toDisplayString(_ctx.$t("home_modal_tab_title_symptoms")), 3),
              _createElementVNode("li", {
                class: _normalizeClass(["modal-tab-item", isSelected.value === 'feeling' ? 'active' : '']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (select('feeling')))
              }, _toDisplayString(_ctx.$t("home_modal_tab_title_feeling")), 3)
            ]),
            (isSelected.value === 'symptom')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t("home_modal_tab_text_symptoms")) + " ", 1),
                    _createElementVNode("img", {
                      src: "/server/necs/images/icon_info.svg",
                      alt: "情報",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (infoModal.open && infoModal.open(...args)))
                    })
                  ]),
                  _createElementVNode("ul", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recordList.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: "daily-record-contents-item"
                      }, [
                        _createElementVNode("p", _hoisted_9, [
                          _cache[7] || (_cache[7] = _createElementVNode("img", {
                            src: "/server/necs/images/icon_category.svg",
                            alt: "カテゴリー"
                          }, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.$t("home_modal_label_category")), 1)
                        ]),
                        _createElementVNode("ul", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredNoteCategoryOptions.value, (option) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: `daily-record-category-${index}-${option.option_id}`,
                              class: _normalizeClass(["daily-record-category-item", [
                  getCategoryClass(option.value),
                  item.category === String(option.option_id) ? 'active' : '',
                ]])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                id: `daily-record-category-${index + 1}-${option.option_id}`,
                                value: String(option.option_id),
                                "onUpdate:modelValue": ($event: any) => ((item.category) = $event)
                              }, null, 8, _hoisted_11), [
                                [_vModelRadio, item.category]
                              ]),
                              _createElementVNode("label", {
                                for: `daily-record-category-${index + 1}-${
                    option.option_id
                  }`
                              }, _toDisplayString(option.display_name), 9, _hoisted_12)
                            ], 2))
                          }), 128))
                        ]),
                        _createVNode(CharCounterTextArea, {
                          modelValue: item.content,
                          "onUpdate:modelValue": ($event: any) => ((item.content) = $event),
                          maxlength: 50,
                          placeholder: "詳しい体調や、がんばったこと、できごとなど",
                          "custom-textarea-wrapper": "daily-record-contents-item-textarea-container",
                          "textarea-class": "daily-record-contents-item-textarea",
                          "char-counter-class": "daily-record-contents-item-textarea-count"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "daily-record-delete-button active",
                          onClick: ($event: any) => (handleDeleteNoteBtnClick(item, index))
                        }, [
                          _cache[8] || (_cache[8] = _createElementVNode("span", null, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.$t("home_modal_button_delete_note")), 1)
                        ], 8, _hoisted_13)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["daily-record-add-button", { 'is-disabled': isNoteLimitReached() }]),
                      disabled: isNoteLimitReached(),
                      onClick: handleAddNote
                    }, [
                      _createElementVNode("img", {
                        src: 
                isNoteLimitReached()
                  ? '/server/necs/images/icon_add_circle_DDD.svg'
                  : '/server/necs/images/icon_add_circle.svg'
              ,
                        alt: "追加"
                      }, null, 8, _hoisted_16),
                      _createTextVNode(_toDisplayString(_ctx.$t("home_modal_button_add_note")), 1)
                    ], 10, _hoisted_15)
                  ])
                ]))
              : _createCommentVNode("", true),
            (isSelected.value === 'feeling')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("home_modal_tab_text_feeling")), 1),
                  _createElementVNode("ul", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.feelingOptions, (option) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `daily-record-feeling-${option.option_id}`,
                        class: "daily-record-feelings-item"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: `feeling-${option.option_id}`,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((feelings).value = $event)),
                          value: String(option.option_id),
                          class: "daily-record-feelings-checkbox"
                        }, null, 8, _hoisted_20), [
                          [_vModelCheckbox, feelings.value]
                        ]),
                        _createElementVNode("label", {
                          for: `feeling-${option.option_id}`,
                          class: "daily-record-feelings-label"
                        }, [
                          _createElementVNode("img", {
                            class: "daily-record-feelings-item-icon",
                            src: getFeelingIcon(option.value),
                            alt: option.display_name
                          }, null, 8, _hoisted_22),
                          _createElementVNode("p", _hoisted_23, _toDisplayString(option.display_name), 1),
                          _cache[9] || (_cache[9] = _createElementVNode("img", {
                            class: "daily-record-feelings-item-check",
                            src: "/server/necs/images/icon_check_feeling.svg",
                            alt: "チェック"
                          }, null, -1))
                        ], 8, _hoisted_21)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  type: "button",
                  class: "modal-cansel",
                  onClick: close
                }, _toDisplayString(_ctx.$t("home_modal_button_cancle")), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "modal-ok",
                  onClick: handleSaveButtonClick
                }, _toDisplayString(_ctx.$t("home_modal_button_save")), 1)
              ])
            ])
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_unref(errorDialog).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 1 }, _unref(errorDialog), {
          onOk: _unref(errorDialog).ok,
          onCancel: _unref(errorDialog).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true),
    (infoModal.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                type: "button",
                class: "modal-close",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (infoModal.close && infoModal.close(...args)))
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("img", { src: "/server/necs/images/close-btn.png" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("img", {
                  class: "popup-contents-img",
                  src: "/server/necs/images/image_note_help.png",
                  alt: _ctx.$t('home_modal_tab_title_symptoms')
                }, null, 8, _hoisted_31),
                _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("home_modal_tab_title_symptoms")), 1),
                _createElementVNode("p", _hoisted_33, [
                  _createTextVNode(_toDisplayString(_ctx.$t("home_modal_info_modal_label_content_1")), 1),
                  _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("home_modal_info_modal_label_content_2")), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  type: "button",
                  class: "modal-button-next",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (infoModal.close && infoModal.close(...args)))
                }, _toDisplayString(_ctx.$t("home_modal_info_modal_button_close")), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})